import SuperJSON from "superjson";
import Id from "../types/Id";

export default class TaskId extends Id<"task"> {}

SuperJSON.registerClass(TaskId, { identifier: "TaskId" });
